import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/App-Context";
import BubbleDisplayImg from "./bubblesDisplay/BubbleDisplayImg";
import OcancerzStarszPostItems from "../../../../OcancerzHeaven/OcancerzStarsz/OcancerzStarszPostItems";

const TgridEditorForm = (props) => {
  const auth = useContext(AuthContext);

  const BUBBLE_KIT_MAP = {
    HUM1: "human",
    HOM2: "home",
    GEO3: "geo",
    FIR4: "fireworks",
    P3D5: "portrait3d",
    TRP6: "portraittrap",
    AFR7: "portraitafrica",
    AFZ8: "portraitafricazone",
    AFW9: "africawesttrap",
    AFS0: "africasouthtrap",
    LTK1: "letterkit",
    LHK2: "letterhebrewkit",
    LHT3: "letterhebrewtextkit",
    LGT4: "lettergreektextkit",
    WDK1: "wordkindkit",
    WDH2: "wordhidekit",
    WDA3: "wordanimalkit",
    WKC4: "wordkindcontourkit",
    WNC5: "wordnocontourkit",
    WAC6: "wordanimalcontourkit",
    CTK7: "customtextcontourkit",
    ROD1: "road",
    CAR1: "car",
    CUB1: "carcube",
    CBT2: "carcubetilt",
    CBS3: "carcubesegment",
    CBF4: "carcubefused",
    CBA5: "carcubealign",
    AUR1: "aura",
    RDO1: "radarone",
    RDT2: "radartwo",
    GUA1: "guardian",
    GHO1: "ghost",
    STR1: "starlight",
    HPR1: "humanpresence",
    RBW1: "starspirit",
  };

  const STAR_TRAIL_KITS = ["starspirit"];

  const [processedImages, setProcessedImages] = useState({});
  const [activeKit, setActiveKit] = useState("none");

  const formatShortTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr
      .replace(/, \d{4}/, "")
      .replace(/\s*[a-z]{3}$/i, "")
      .trim();
  };

  const [data, setData] = useState(null);
  const [userIdData, setuserIdData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const thePostObject = {
    uid: props.editingPost?.uid,
    postText: props.editingPost?.postText,
    postDate: props.editingPost?.postDate,
    postImages: props.editingPost?.postImages,
    starsinConstellation: props.editingPost?.starsinConstellation,
  };

  const handleBubblesClick = () => {
    if (props.editingPost?.onEditPost) {
      props.onEditPost(thePostObject);
    }
  };

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(true);

    if (props.editingPost?.postImages !== undefined) {
      setData(props.editingPost.postImages || []);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getImagesTempleGridpost?username=${auth.loginVar}&uid=${thePostObject.uid}`
        );
        setData(response.data.data.functionGo);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    if (thePostObject.uid) {
      fetchData();
    }
  }, [auth.loginVar, props.editingPost?.uid]);

  const handleProcessed = (originalSrc, processedDataUrl) => {
    setProcessedImages((prev) => ({
      ...prev,
      [originalSrc]: processedDataUrl,
    }));
  };

  const [isSubmittingBubble, setIsSubmittingBubble] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getUserByParameters/${auth.loginVar}`
        );
        setuserIdData(response.data.data);
      } catch (err) {
      } finally {
      }
    };
    fetchData();
  }, [auth.loginVar]);

  const isStarOrConstellation =
    props.editingPost?.starsinConstellation !== undefined;

  const handleAddBubble = async () => {
    if (activeKit === "none") {
      alert("Please select a Kit to attach to this bubble first!");
      return;
    }

    if (!userIdData || !userIdData[0]?.username) {
      alert("User data is still loading. Please try again in a moment.");
      return;
    }

    const hiddenKitCode =
      Object.keys(BUBBLE_KIT_MAP).find(
        (key) => BUBBLE_KIT_MAP[key] === activeKit
      ) || activeKit;
    setIsSubmittingBubble(true);

    if (userIdData[0].username && thePostObject.uid) {
      let correctFileTag =
        thePostObject.uid.slice(-3) === "tID" ? ".tgrid" : ".zrbh";
      let endpointUrl = `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/updateTempleGridBubbles`;

      if (props.editingPost?.postType === "star") {
        endpointUrl = `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/updateOcancerStarPostBubbles`;
        correctFileTag =
          thePostObject.uid.slice(-3) === "tID" ? ".tgrid" : ".tgrid.spirit";
      } else if (props.editingPost?.postType === "constellation") {
        endpointUrl = `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/updateOcancerStarFormBubbles`;
        correctFileTag =
          thePostObject.uid.slice(-3) === "tID" ? ".tgrid" : ".tgrid.spirit";
      }

      const isStarTrailKit = STAR_TRAIL_KITS.includes(activeKit);

      try {
        const bubblePayload = {
          userUsername: userIdData[0].username,
          postID: userIdData[0].uID + "_" + thePostObject.uid + correctFileTag,
          templeGridpostBubblesData: {
            activeKit: activeKit,
            hiddenCode: hiddenKitCode,
            imageBubbles: ["buubleID"],
            typeofPost: isStarTrailKit ? "starTrail" : "standard",
          },
        };

        await axios.post(endpointUrl, bubblePayload, {});
        alert("Bubble successfully attached to post!");
      } catch (error) {
        console.error("Bubble upload failed:", error);
        alert("Failed to attach bubble. Please try again.");
      } finally {
        setIsSubmittingBubble(false);
      }
    } else {
      alert("Missing User ID or Post ID. Cannot attach bubble.");
      setIsSubmittingBubble(false);
    }
  };

  return (
    <div
      className="create-post-card"
      style={{
        boxSizing: "border-box", // 🌟 PREVENTS PARENT OVERFLOW
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      {props.editingPost && (
        <div>
          <div> {props.editingPost.postText}</div>
          <div> {props.editingPost.postDate}</div>
        </div>
      )}

      {Array.isArray(data) && data.length > 0 && (
        <div className="photo-grid">
          {data.map((photo, index) => {
            const imageSrc = photo.url || photo.src;
            return (
              <div
                key={photo.key || photo.filename || `photo-${index}`}
                className="photo-item"
                role="button"
                tabIndex={0}
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <BubbleDisplayImg
                  src={imageSrc}
                  alt={photo.filename || `Photo ${index + 1}`}
                  showOcancer={false}
                  activeKit={
                    STAR_TRAIL_KITS.includes(activeKit) ? "none" : activeKit
                  }
                  onProcessed={(dataUrl) => handleProcessed(imageSrc, dataUrl)}
                />

                {photo.time && (
                  <div style={{ marginTop: "6px", textAlign: "left" }}>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#007bff",
                        fontWeight: "bold",
                      }}
                    >
                      {formatShortTime(photo.time)}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {thePostObject.starsinConstellation &&
        thePostObject.starsinConstellation.length > 0 && (
          <div
            style={{
              marginTop: "20px",
              paddingTop: "15px",
              borderTop: "2px dashed #ccc",
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <h4
              style={{
                margin: "0 0 15px 0",
                color: "#00008b",
                textAlign: "center",
              }}
            >
              Connected Stars
            </h4>
            <div
              className="hide-scrollbar"
              style={{
                display: "flex",
                overflowX: "auto",
                gap: "20px",
                paddingBottom: "15px",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {thePostObject.starsinConstellation.map((starId, i) => (
                <div
                  key={`${starId}-${i}`}
                  style={{
                    minWidth: "320px",
                    width: "320px",
                    flexShrink: 0,
                    border: "1px solid #e0e0e0",
                    borderRadius: "14px",
                    background: "#ffffff",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                    overflow: "hidden",
                    scrollSnapAlign: "start",
                  }}
                >
                  <OcancerzStarszPostItems
                    postFunction={starId}
                    isPreviewMode={true}
                    inheritedStarTrailBubbles={
                      STAR_TRAIL_KITS.includes(activeKit)
                        ? [
                            {
                              templeGridpostBubblesData: {
                                activeKit: activeKit,
                              },
                            },
                          ]
                        : []
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        )}

      <div
        className="post-actions"
        style={{ width: "100%", boxSizing: "border-box" }}
      >
        <div
          className="post-icons"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            paddingBottom: "10px",
          }}
        >
          {props.editingPost?.postType === "constellation" && (
            <div
              style={{
                width: "100%",
                flex: "0 0 100%",
                marginTop: "10px",
                marginBottom: "10px",
                padding: "12px",
                background: "rgba(123, 0, 255, 0.04)",
                border: "1px solid rgba(123, 0, 255, 0.15)",
                borderRadius: "12px",
                boxSizing: "border-box", // 🌟 FIXES THE SCROLLBAR OVERFLOW
              }}
            >
              <h4
                style={{
                  margin: "0 0 8px 0",
                  color: "#7b00ff",
                  fontSize: "13px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                ✨ Star Trails
              </h4>
              <button
                type="button"
                className="icon-btn"
                style={{
                  display: "inline-block",
                  margin: "4px",
                  fontWeight: activeKit === "starspirit" ? "bold" : "normal",
                  color: activeKit === "starspirit" ? "#ffffff" : "#7b00ff",
                  background:
                    activeKit === "starspirit" ? "#7b00ff" : "transparent",
                  border: "1px solid #7b00ff",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setActiveKit(
                    activeKit === "starspirit" ? "none" : "starspirit"
                  )
                }
              >
                ✨ Star spirit
              </button>
            </div>
          )}

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "human" ? "bold" : "normal",
              color: activeKit === "human" ? "blue" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "human" ? "none" : "human")
            }
          >
            😄 human kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "home" ? "bold" : "normal",
              color: activeKit === "home" ? "blue" : "black",
            }}
            onClick={() => setActiveKit(activeKit === "home" ? "none" : "home")}
          >
            🏠 home kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "geo" ? "bold" : "normal",
              color: activeKit === "geo" ? "red" : "black",
            }}
            onClick={() => setActiveKit(activeKit === "geo" ? "none" : "geo")}
          >
            📍 geo kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "fireworks" ? "bold" : "normal",
              color: activeKit === "fireworks" ? "magenta" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "fireworks" ? "none" : "fireworks")
            }
          >
            🎆 fireworks kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "portrait3d" ? "bold" : "normal",
              color: activeKit === "portrait3d" ? "#ff00ff" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "portrait3d" ? "none" : "portrait3d")
            }
          >
            🔲 portrait 3d kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "aura" ? "bold" : "normal",
              color: activeKit === "aura" ? "#ff00ff" : "black",
            }}
            onClick={() => setActiveKit(activeKit === "aura" ? "none" : "aura")}
          >
            ✨ aura kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "radarone" ? "bold" : "normal",
              color: activeKit === "radarone" ? "#00ff00" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "radarone" ? "none" : "radarone")
            }
          >
            🌊 radar one kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "radartwo" ? "bold" : "normal",
              color: activeKit === "radartwo" ? "#0088ff" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "radartwo" ? "none" : "radartwo")
            }
          >
            🌊 radar two kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "portraittrap" ? "bold" : "normal",
              color: activeKit === "portraittrap" ? "#b84dff" : "black",
            }}
            onClick={() =>
              setActiveKit(
                activeKit === "portraittrap" ? "none" : "portraittrap"
              )
            }
          >
            ⏢ trap kit
          </button>

          {/* <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight:
                activeKit === "portraitafricazone" ? "bold" : "normal",
              color: activeKit === "portraitafricazone" ? "#ff3333" : "black",
            }}
            onClick={() =>
              setActiveKit(
                activeKit === "portraitafricazone"
                  ? "none"
                  : "portraitafricazone"
              )
            }
          >
            🌍 africa zone kit
          </button> */}

          {/* <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "africawesttrap" ? "bold" : "normal",
              color: activeKit === "africawesttrap" ? "#ff3333" : "black",
            }}
            onClick={() =>
              setActiveKit(
                activeKit === "africawesttrap" ? "none" : "africawesttrap"
              )
            }
          >
            ⏢ Active Alert
          </button> */}

          {/* <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "africasouthtrap" ? "bold" : "normal",
              color: activeKit === "africasouthtrap" ? "#ff3333" : "black",
            }}
            onClick={() =>
              setActiveKit(
                activeKit === "africasouthtrap" ? "none" : "africasouthtrap"
              )
            }
          >
            ⏢ Active Alert
          </button> */}

          <div
            style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}
          >
            <button
              type="button"
              className="icon-btn"
              style={{
                fontWeight:
                  activeKit === "customtextcontourkit" ? "bold" : "normal",
                color:
                  activeKit === "customtextcontourkit" ? "#ff00ff" : "black",
              }}
              onClick={() => {
                const formUI = document.getElementById("customTextFormUI");
                if (formUI)
                  formUI.style.display =
                    formUI.style.display === "none" ? "flex" : "none";
              }}
            >
              📜 custom kit
            </button>
          </div>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "carcube" ? "bold" : "normal",
              color: activeKit === "carcube" ? "#00ffff" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "carcube" ? "none" : "carcube")
            }
          >
            🧊 car cube kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "ghost" ? "bold" : "normal",
              color: activeKit === "ghost" ? "#a9a9a9" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "ghost" ? "none" : "ghost")
            }
          >
            👻 ghost kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "guardian" ? "bold" : "normal",
              color: activeKit === "guardian" ? "#ffaa00" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "guardian" ? "none" : "guardian")
            }
          >
            🛡️ guardian kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              fontWeight: activeKit === "starlight" ? "bold" : "normal",
              color: activeKit === "starlight" ? "#00e5ff" : "black",
            }}
            onClick={() =>
              setActiveKit(activeKit === "starlight" ? "none" : "starlight")
            }
          >
            🌌 starlight kit
          </button>

          <button
            type="button"
            className="icon-btn"
            style={{
              display: "inline-block",
              margin: "4px",
              fontWeight: activeKit === "humanpresence" ? "bold" : "normal",
              color: activeKit === "humanpresence" ? "#00ffff" : "black",
            }}
            onClick={() =>
              setActiveKit(
                activeKit === "humanpresence" ? "none" : "humanpresence"
              )
            }
          >
            ➕ human presence
          </button>

          <div
            id="customTextFormUI"
            style={{ display: "none", gap: "5px", alignItems: "center" }}
          >
            <input
              type="text"
              id="customMatrixInput"
              maxLength={56}
              placeholder="Type word..."
              style={{
                width: "120px",
                padding: "2px 5px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setActiveKit("none");
                  setTimeout(() => setActiveKit("customtextcontourkit"), 10);
                }
              }}
            />
            <button
              type="button"
              style={{
                cursor: "pointer",
                padding: "2px 6px",
                background: "#333",
                color: "white",
                borderRadius: "4px",
                border: "none",
              }}
              onClick={() => {
                setActiveKit("none");
                setTimeout(() => setActiveKit("customtextcontourkit"), 10);
              }}
            >
              Render
            </button>
          </div>
        </div>

        <button
          className="btn-submit"
          onClick={handleAddBubble}
          style={{
            opacity: isSubmittingBubble || activeKit === "none" ? 0.5 : 1,
            cursor:
              isSubmittingBubble || activeKit === "none"
                ? "not-allowed"
                : "pointer",
          }}
        >
          {isSubmittingBubble ? "Saving Bubble..." : "Add Bubble ⚡"}
        </button>
      </div>
    </div>
  );
};

export default TgridEditorForm;
